import {
  PNL_COLORS,
  BUTTERFLY_LEFT_WING_CATEGORIES,
  BUTTERFLY_RIGHT_WING_CATEGORIES,
  ALL_PNL_CATEGORIES,
} from "constants/constants";

import { OverallBarstackStyles } from "./OverallBarstackStyles";
import styled from "styled-components/macro";
import { useIsDarkMode } from "store/atoms";

const ANIMATION_DURATION = 3.8;
const ANIMATION_EASING = "cubic-bezier(0.3, 0.05, 0.45, 1)";
const WIDTH_STEPS = [0.4, 1]; // min and max width percents of each animating bar

const LEFT_WING_CATEGORIES_RATIO =
  BUTTERFLY_LEFT_WING_CATEGORIES.length / ALL_PNL_CATEGORIES.length;
const RIGHT_WING_CATEGORIES_RATIO =
  BUTTERFLY_RIGHT_WING_CATEGORIES.length / ALL_PNL_CATEGORIES.length;
const RIGHT_TO_LEFT_RATIO =
  BUTTERFLY_RIGHT_WING_CATEGORIES.length /
  BUTTERFLY_LEFT_WING_CATEGORIES.length;

// to ensure the animation is already started (no delays > 0s), subtract this amount from the animation delay
const OFFSET_ANIMATION_START = ALL_PNL_CATEGORIES.length * ANIMATION_DURATION;

const OverallBarstackLoaderSkeleton = () => {
  const [isDarkMode] = useIsDarkMode();
  return (
    <LoaderAnimationStyles>
      <OverallBarstackStyles
        data-component-name={"Overall Barstack"}
        $isDarkMode={isDarkMode}
      >
        <div className="leftStack">
          {BUTTERFLY_LEFT_WING_CATEGORIES.map(({ category }, idx) => {
            const animationDelay = (idx + 1) * RIGHT_TO_LEFT_RATIO;

            return (
              <div
                key={category}
                className={`pnlBarHorizontal profit ${
                  idx === 0 ? " first" : ""
                }${
                  idx === BUTTERFLY_LEFT_WING_CATEGORIES.length - 1
                    ? " last"
                    : ""
                }`}
                style={{
                  backgroundColor: PNL_COLORS[category],
                  animation: `profitGrowX ${ANIMATION_DURATION}s infinite ${
                    animationDelay - OFFSET_ANIMATION_START
                  }s ${ANIMATION_EASING}`,
                }}
              />
            );
          })}
          <div className="pnlBarSpacer" />
        </div>
        <div className="barstackSpacer" />
        <div className="rightStack">
          {BUTTERFLY_RIGHT_WING_CATEGORIES.map(({ category }, idx) => {
            const inverseIdx = BUTTERFLY_RIGHT_WING_CATEGORIES.length - 1 - idx;
            const animationDelay = inverseIdx + 1;

            return (
              <div
                key={category}
                className={`pnlBarHorizontal loss ${idx === 0 ? " first" : ""}${
                  idx === BUTTERFLY_RIGHT_WING_CATEGORIES.length - 1
                    ? " last"
                    : ""
                }`}
                style={{
                  backgroundColor: PNL_COLORS[category],
                  animation: `lossGrowX ${ANIMATION_DURATION}s infinite ${
                    animationDelay - OFFSET_ANIMATION_START
                  }s ${ANIMATION_EASING}`,
                }}
              />
            );
          })}
          <div className="pnlBarSpacer" />
        </div>
      </OverallBarstackStyles>
    </LoaderAnimationStyles>
  );
};

const makeKeyFrames = maxWidthPct => {
  return WIDTH_STEPS.reduce(
    (acc, step, idx) => {
      acc += `
      ${(100 * (idx + 1)) / WIDTH_STEPS.length}% {
        flex-grow: ${maxWidthPct * step};
      }
      `;
      return acc;
    },
    `0% {
      flex-grow: ${maxWidthPct * WIDTH_STEPS[WIDTH_STEPS.length - 1]};
    }`
  );
};

const LOSS_KEYFRAMES = makeKeyFrames(LEFT_WING_CATEGORIES_RATIO * 100);
const PROFIT_KEYFRAMES = makeKeyFrames(RIGHT_WING_CATEGORIES_RATIO * 100);

const LoaderAnimationStyles = styled.div`
  .pnlBarHorizontal {
    opacity: 0.3;
  }
  .leftStack,
  .rightStack {
    height: 41px;
    display: flex;
    flex-grow: 1;
  }
  @keyframes lossGrowX {
    ${LOSS_KEYFRAMES}
  }
  @keyframes profitGrowX {
    ${PROFIT_KEYFRAMES}
  }
`;

export default OverallBarstackLoaderSkeleton;
